/* import __COLOCATED_TEMPLATE__ from './phone-details-fin-search-group.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type Session from 'embercom/services/session';
import type { ResolvedSource } from './phone-details-call-transcription';

interface PhoneDetailsFinSearchGroupSignature {
  Args: {
    searchQuery: string;
    sources: ResolvedSource[];
  };
  Element: HTMLDivElement;
}

export default class PhoneDetailsFinSearchGroup extends Component<PhoneDetailsFinSearchGroupSignature> {
  @service declare session: Session;

  @tracked isExpanded = false;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::PhoneDetailsFinSearchGroup': typeof PhoneDetailsFinSearchGroup;
    'inbox2/phone-details-fin-search-group': typeof PhoneDetailsFinSearchGroup;
  }
}
